/**
 * OnboardingFAB - Floating Action Button for Onboarding
 *
 * Displays a fixed FAB in the bottom-right corner with:
 * - Primary button that matches the design system
 * - Enabled only when required steps (1 & 3) are completed
 */

import React from 'react';

export function OnboardingFAB({
  step1Completed,
  step3Completed,
  canGoToDashboard,
  onClick,
  disabled = false,
  requiredStepsCount, // optional (kept for compatibility / future use)
}) {
  // Use canAccessDashboard from API when provided, else derive from steps (Step 2 is optional)
  const requiredStepsCompleted = Boolean(
    canGoToDashboard ?? (step1Completed && step3Completed),
  );
  const isDisabled = Boolean(disabled || !requiredStepsCompleted);

  return (
    <div className="fixed bottom-8 right-8 z-50 flex flex-col items-end gap-3">
      {/* Primary Button - Consistent Design */}
      <button
        type="button"
        onClick={onClick}
        disabled={isDisabled}
        className={`
          px-8 py-4 rounded-full
          font-['Roboto:Bold',sans-serif] font-bold text-[16px]
          shadow-[0px_4px_20px_rgba(0,0,0,0.25)]
          transition-all duration-300 ease-in-out
          flex items-center gap-3
          ${
            requiredStepsCompleted
              ? 'bg-[#61b8e7] text-white hover:bg-[#4fa3d1] hover:shadow-[0px_8px_30px_rgba(97,184,231,0.4)] hover:scale-105 cursor-pointer'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }
        `}
        style={{ fontVariationSettings: "'wdth' 100" }}
      >
        Go to Dashboard
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2.5}
            d="M13 7l5 5m0 0l-5 5m5-5H6"
          />
        </svg>
      </button>
    </div>
  );
}
